import {
    COLLABORATOR_CHART,
    COLLABORATOR_PROFILE_SELECT,
    KEYWORD_COLLABORATION_CHART,
    PROFILE_COLLABORATOR_CHART,
    COLLABORATOR_PROFILE_SEARCH_CHANGE,
    COLLABORATOR_SEARCH_PROFILES,
    CHANGE_COLLABS_LABEL
} from '../actions/types';

const initialState = {
    collaborators: {},
    keyword: '',
    keywordKeyword: '',
    collabsKeyword: '',
    keywordCollaboration: {},
    profileCollaborators: {},
    selectedProfile: "",
    isProfileSelected: false,
    isProfileSearchActive: false,
    profiles: [],
    isLabelsOn: false
}

export default (state = initialState, action) => {
    switch (action.type) {
        case COLLABORATOR_CHART:
            return {
                ...state,
                keyword: action.payload.keyword,
                collaborators: action.payload.data,
                collabsKeyword: action.payload.keyword
            }
            break;
        case CHANGE_COLLABS_LABEL:
            return {
                ...state,
                isLabelsOn: action.payload.isLabelsOn
            }
            break;
        case PROFILE_COLLABORATOR_CHART:
            return {
                ...state,
                keyword: action.payload.keyword,
                profileCollaborators: action.payload.data,
                collabsKeyword: action.payload.keyword,
                selectedProfile: action.payload.keyword,
                profiles: [],
                isProfileSelected: true
            }
            break;
        case KEYWORD_COLLABORATION_CHART:
            return {
                ...state,
                keyword: action.payload.keyword,
                keywordCollaboration: action.payload.data,
                keywordKeyword: action.payload.keyword
            }
            break;
        case COLLABORATOR_PROFILE_SELECT:
            return {
                ...state,
                selectedProfile: action.payload.selectedProfile,
                isProfileSelected: true
            }
            break;
        case COLLABORATOR_PROFILE_SEARCH_CHANGE:
            return {
                ...state,
                isProfileSearchActive: action.payload.isProfileSearchActive
            }
            break;
        case COLLABORATOR_SEARCH_PROFILES :
            return {
                ...state,
               profiles: action.payload.profiles || [],
               selectedProfile: '',
               isProfileSelected: false,
            }
            break;
        default:
            return state;
            break;
    }
}